import { render, staticRenderFns } from "./AxTrip.vue?vue&type=template&id=65ebfafe&scoped=true&"
import script from "./AxTrip.vue?vue&type=script&lang=js&"
export * from "./AxTrip.vue?vue&type=script&lang=js&"
import style0 from "./AxTrip.vue?vue&type=style&index=0&id=65ebfafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ebfafe",
  null
  
)

export default component.exports